import { Link, useMatch } from "react-router-dom";
import { Menu, Container } from "semantic-ui-react";
import React from "react";
export const FormBuilderMenu = ({ formKey }) => {
    // Define menu items with their paths and labels
    const menuItems = [
        { path: `/form-config/${formKey}`, label: 'Builder Workspace' },
        { path: `/form-config/${formKey}/builder`, label: 'Model Configuration' },
        { path: `/form-config/${formKey}/preview/cards`, label: 'Preview' },
        { path: `/form-config/${formKey}/share`, label: 'Publish' }
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement(Menu, { pointing: true, className: "secondary-menu" }, menuItems.map((item) => {
            const isActive = useMatch(item.path) !== null;
            return (React.createElement(Menu.Item, { key: item.path, as: Link, to: item.path, active: isActive, name: item.label }));
        }))));
};
export const FormBuilderLayout = ({ formKey, children }) => {
    return React.createElement("div", null, children);
};
export const FormBuilderLayoutWithMenu = ({ formKey, children }) => {
    return React.createElement("div", null,
        React.createElement(FormBuilderMenu, { formKey: formKey }),
        React.createElement(Container, { fluid: true }, children));
};
